// Section 5 and 11: Quick learner. Skill gain 1.5x. Constants: config.traits['quick-learner'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function quickLearner(config: Config) {
  return defineTrait({
    id: 'quick-learner',
    label: 'Quick learner',
    section: 'S5',
    modifierTargets: ['skillGain'],
    modifiers(ctx, target) {
      return target.kind === 'skillGain' &&
        targetPerson(ctx, target)?.traits.includes('quick-learner') === true
        ? [
            mod.mul(
              'trait:quick-learner',
              config.traits['quick-learner'].skillGainMul,
              'quick learner',
            ),
          ]
        : [];
    },
    restricts: neverRestricts,
  });
}
